import * as React from "react";
const SvgFiRrSynagogue = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-synagogue_svg__a)">
      <path
        fill="#062147"
        d="M9.182 11.09 9.836 10l-.654-1.09a.533.533 0 0 1 .457-.807h1.336l.568-.946a.533.533 0 0 1 .914 0l.568.946h1.336c.414 0 .67.452.457.807L14.164 10l.654 1.09a.533.533 0 0 1-.457.807h-1.336l-.568.946a.533.533 0 0 1-.914 0l-.568-.946H9.639a.533.533 0 0 1-.457-.807M24 13.743V20c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4v-6.257c0-.916.41-1.77 1.125-2.342l1.154-.923a2.005 2.005 0 0 1 2.425-.056l.295.215V6.5c0-1.252.598-2.45 1.6-3.2l3.6-2.7a3.02 3.02 0 0 1 3.6 0l3.6 2.7a4.02 4.02 0 0 1 1.6 3.2v4.138l.295-.214a2 2 0 0 1 2.426.056l1.153.922a2.98 2.98 0 0 1 1.126 2.342zM7 6.5V22h2v-4c0-1.654 1.346-3 3-3s3 1.346 3 3v4h2V6.5a2.01 2.01 0 0 0-.8-1.6l-3.6-2.701a1.01 1.01 0 0 0-1.201 0L7.8 4.899c-.501.376-.8.975-.8 1.6M13 18c0-.551-.449-1-1-1s-1 .449-1 1v4h2zm-9 4h1v-8.891l-1.471-1.07-1.154.924a1 1 0 0 0-.375.78v6.258C2 21.104 2.897 22 4 22m18-8.257a1 1 0 0 0-.375-.781l-1.153-.923-1.471 1.07v8.89h1c1.103 0 2-.896 2-2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-synagogue_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSynagogue;
